var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          on: {
            "click:outside": function ($event) {
              return _vm.closeDialog()
            },
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "d-flex flex-column px-12 py-12 gap-6",
              staticStyle: { overflow: "hidden" },
            },
            [
              _c("v-icon", { attrs: { size: "60", color: "primary" } }, [
                _vm._v(" mdi-alert-circle-outline "),
              ]),
              _c(
                "div",
                { staticClass: "d-flex flex-column align-center gap-2" },
                [
                  _c("span", { staticClass: "text-body-bold" }, [
                    _vm._v("บันทึกการเปลี่ยนแปลง ?"),
                  ]),
                  _c(
                    "span",
                    { staticClass: "text-description field-grey--text" },
                    [_vm._v("คุณแน่ใจใช่ไหมว่าต้องการบันทึกการเปลี่ยนแปลง ?")]
                  ),
                ]
              ),
              _c("v-divider"),
              _c(
                "div",
                { staticClass: "d-flex gap-4 align-center justify-end" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "primary--text cs-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_vm._v("ยกเลิก")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.loading || _vm.$apollo.loading,
                        loading: _vm.loading || _vm.$apollo.loading,
                        color: "primary",
                        depressed: "",
                        rounded: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.confirm()
                        },
                      },
                    },
                    [_vm._v(" ยืนยัน ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.items.length
        ? _c("v-data-table", {
            staticClass: "app-table mt-4",
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.status`,
                  fn: function () {
                    return [
                      _c("v-switch", {
                        staticClass: "mb-4",
                        attrs: {
                          disabled: _vm.loading || _vm.$apollo.loading,
                          loading: _vm.loading || _vm.$apollo.loading,
                          inset: "",
                          "hide-details": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.toggleSwitch($event)
                          },
                        },
                        model: {
                          value: _vm.adEventStatus,
                          callback: function ($$v) {
                            _vm.adEventStatus = $$v
                          },
                          expression: "adEventStatus",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }